// extracted by mini-css-extract-plugin
module.exports = {"BlogpostsCard":"BlogpostsCard_BlogpostsCard__6s6Fh","Body":"BlogpostsCard_Body__bkKlR","Author":"BlogpostsCard_Author__ImG8n","Community":"BlogpostsCard_Community__1YVQg"};